import {CSSProperties, TextareaHTMLAttributes, useLayoutEffect, useRef} from 'react'
import './WidgetPlainText.less'

interface Props {
    text: string
    style?: CSSProperties
    editorProps?: TextareaHTMLAttributes<HTMLTextAreaElement>
}

// The same text determines wrapping and height in both modes, including empty lines.
export const WidgetPlainText = ({text, style, editorProps}: Props) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null)
    const isEditing = !!editorProps

    useLayoutEffect(() => {
        const textarea = textareaRef.current
        if (isEditing && textarea) {
            textarea.focus()
            textarea.setSelectionRange(0, textarea.value.length, 'forward')
        }
    }, [isEditing])

    return (
        <div className='widget-plain-text' style={style}>
            <div className='widget-plain-text-body'>
                <div className='widget-plain-text-value'
                     aria-hidden={editorProps ? true : undefined}
                     style={editorProps ? {visibility: 'hidden'} : undefined}>
                    {text}{(!text || text.endsWith('\n')) && '\u200b'}
                </div>
                {editorProps && (
                    <textarea {...editorProps} ref={textareaRef} value={text} rows={1} />
                )}
            </div>
        </div>
    )
}
